export default __webpack_public_path__ + "images/low_lying_blue.4ce4779ea541b1ca01c9f7501769ab43.png";